import React, { useState, useEffect } from "react";
import {
  Tab,
  Button,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { BasicDrawer } from "../../../components/Shared";
import {
  ListWasteForms,
  WasteForm,
} from "../../../components/Admin/WasteForms";
import { useAuth } from "../../../hooks";
import { Form, Wasteform } from "../../../api";
import { encrypt, decrypt } from "../../../utils/cryptoUtils";
import { useLocation, useNavigate } from "react-router-dom";

// `text` sale de las traducciones (t(key)) al renderizar, no acá — estos
// keys ("water", "effluent", etc.) ya existen en los .json de i18n.
const QUESTIONNAIRE_OPTIONS = [
  { key: "water",       value: "/admin/data/waterforms" },
  { key: "effluent",    value: "/admin/data/effluentforms" },
  // { key: "air",          value: "/admin/data/airemissionsforms" },
  { key: "energy",      value: "/admin/data/energyforms" },
  // { key: "envobjetives", value: "/admin/data/environmentalobjetives" },
  { key: "production",  value: "/admin/data/productionforms" },
  { key: "waste",       value: "/admin/data/wasteforms" },
  { key: "social",      value: "/admin/data/socialforms" },
  { key: "fuel",        value: "/admin/data/fuelsforms" },
];
import {
  hasPermission,
  isAdmin,
  isMaster,
  isEditor,
} from "../../../utils/checkPermission";
import "./WasteForms.scss";
import { useLanguage, useSite } from "../../../contexts";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { wasteCodes } from "../../../utils/dataAndFormulas/wasteForms";

const formController = new Form();
const wasteFormController = new Wasteform();

export function WasteForms() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const {
    accessToken,
    user: { role, site },
  } = useAuth();
  const [siteSelected, setSiteSelected] = useState(null);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [configFormData, setConfigFormData] = useState([]);
  const [unitsRecorded, setUnitsRecorded] = useState({});
  const [loading, setLoading] = useState(true);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  // Función para verificar si hay al menos una unidad configurada
  const validateUnitsConfigured = () => {
    // Si no hay configFormData o no hay fields, permitir continuar (usará campos por defecto)
    if (!configFormData?.fields || configFormData.fields.length === 0) {
      return { valid: true };
    }

    // Filtrar solo los campos activos
    const activeFields = configFormData.fields.filter(field => field.active !== false);

    if (activeFields.length === 0) {
      return { valid: false, message: t("no_active_fields") };
    }

    // Verificar que haya al menos UNA unidad configurada
    const fieldsWithUnit = activeFields.filter(field => field.unit && field.unit !== "");

    if (fieldsWithUnit.length === 0) {
      return {
        valid: false,
        message: t("units_not_configured") || "Debe configurar al menos una unidad antes de agregar un periodo. Haga clic en el ícono de tres puntos (⋯) en la columna de Unidades."
      };
    }

    return { valid: true };
  };

  // Función para manejar la apertura del modal de nuevo formulario
  const handleOpenNewForm = () => {
    const validation = validateUnitsConfigured();
    if (!validation.valid) {
      toast.error(validation.message);
      return;
    }
    onOpenCloseModal();
  };

  const location = useLocation();

  const siteContext = useSite().site;

  useEffect(() => {
    (async () => {
      try {
        if (siteContext !== "") {
          setSiteSelected(siteContext);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [siteContext]);

  useEffect(() => {
    (async () => {
      try {
        if (site) {
          setSiteSelected(site);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      try {
        if (location.state?.siteSelected) {
          setSiteSelected(decrypt(location.state.siteSelected));
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [location]);

    useEffect(() => {
      (async () => {
        try {
            setLoading(true);
            if (siteSelected && siteSelected !== "" && siteSelected !=="undefined") {
              const response = await formController.getFormsBySite(
                accessToken,
                siteSelected,
                "waste"
              );
              console.log("🔄 WasteForms: getFormsBySite response:", response);
              console.log(`⚠️ IMPORTANTE: Se encontraron ${response.length} documentos Form de waste para este sitio`);

              if (response.length > 1) {
                console.error("❌ ERROR: HAY MÚLTIPLES DOCUMENTOS FORM DE WASTE");
                console.log("📋 Todos los Forms encontrados:", response);
                console.log("🔍 IDs de los Forms:", response.map(f => f._id));
              }

              if (response.length > 0) {
                console.log("✅ WasteForms: configFormData actualizado (usando el primero):", response[0]);
                setConfigFormData(response[0]);
              } else {
                console.log("⚠️ WasteForms: No se encontró Form para el sitio");
              }
              setLoading(false);
          }
        } catch (error) {
          console.error("❌ WasteForms: Error al cargar Form:", error);
          setConfigFormData([]);
        }
      })();
    }, [siteSelected, accessToken, reload]);

  // Cargar unidades cuando cambia configFormData o siteSelected
  useEffect(() => {
    (async () => {
      try {
        if (siteSelected && yearSelected) {
          // Determinar campos activos
          const fields = new Set();
          if (configFormData?.fields && configFormData.fields.length > 0) {
            Object.keys(wasteCodes).forEach((key) => {
              if (configFormData.fields.some((field) => field.name === key && field.active)) {
                fields.add(key);
              }
            });
          } else {
            Object.keys(wasteCodes).forEach((key) => {
              fields.add(key);
            });
          }
          const uniqueFields = Array.from(fields);

          if (uniqueFields.length > 0) {
            let recordedUnits = {};

            // 1. Primero intentar obtener las unidades desde configFormData.fields
            if (configFormData?.fields && configFormData.fields.length > 0) {
              configFormData.fields.forEach((field) => {
                if (field.unit && field.name) {
                  recordedUnits[field.name] = field.unit;
                }
              });
            }

            // 2. Si no hay unidades en configFormData, obtener de los formularios guardados
            if (Object.keys(recordedUnits).length === 0) {
              const response = await wasteFormController.getLastUnitFieldsByYear(
                accessToken,
                siteSelected,
                yearSelected,
                uniqueFields
              );

              if (response.code === 200) {
                recordedUnits = response.fields;
              }
            }

            setUnitsRecorded(recordedUnits);
          }
        }
      } catch (error) {
        console.error(error);
        setUnitsRecorded({});
      }
    })();
  }, [configFormData, siteSelected, yearSelected, accessToken, reload]);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          {siteSelected === null &&
          (isMaster(role) || (isAdmin(role) && !site)) ? (
            <div className="no-site-warning">
              <Icon name="warning sign" size="big" />
              <p>{t("select_company_site_from_header")}</p>
            </div>
          ) : (
            <ListWasteForms
              siteSelected={siteSelected}
              yearSelected={yearSelected}
              reload={reload}
              onReload={onReload}
              configFormData={configFormData}
              unitsRecorded={unitsRecorded}
            />
          )}
        </Tab.Pane>
      ),
    },
  ];

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  return (
    <>
      <div className="waste-forms-page">
        <div className="waste-page-header-wrapper">
          <div className="waste-page-header">
            <Dropdown
              className="waste-questionnaire-dropdown"
              options={QUESTIONNAIRE_OPTIONS
                .map((opt) => ({ ...opt, text: t(opt.key) }))
                .sort((a, b) => a.text.localeCompare(b.text, language))}
              selection
              onChange={(_, data) => navigate(data.value)}
              value="/admin/data/wasteforms"
            />
            <div className="waste-page-actions">
              {(siteSelected !== null || site) ? (
                <Dropdown
                  className="waste-year-dropdown"
                  placeholder={t("select")}
                  options={years.map((year) => ({ key: year, text: year, value: year }))}
                  selection
                  onChange={(_, data) => setYearSelected(data.value)}
                  value={yearSelected}
                />
              ) : null}
            </div>
          </div>
          {(siteSelected !== null || site) && (isAdmin(role) || isEditor(role) || isMaster(role)) ? (
            <Button icon className="waste-add-btn" onClick={handleOpenNewForm}>
              <Icon name="plus" />
            </Button>
          ) : null}
        </div>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicDrawer
        show={showModal}
        close={onOpenCloseModal}
      >
        <WasteForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          year={yearSelected}
          siteSelected={siteSelected}
          configFormData={configFormData}
          unitsRecorded={unitsRecorded}
        />
      </BasicDrawer>
    </>
  );
}

